var _path, _ellipse, _path2, _path3, _path4, _path5, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path6, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _ellipse6, _ellipse7, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 35C15 25 20 20 30 18C35 17 40 17 45 20C50 23 53 28 53 35C53 40 50 45 45 47C40 49 35 49 30 47C25 45 22 40 20 35C18 32 15 32 15 35Z",
    fill: "#9ACD32"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 25,
    rx: 18,
    ry: 15,
    fill: "#9ACD32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15C25 12 30 10 35 12C40 14 42 18 40 22C38 20 35 18 32 18C28 18 24 16 20 15Z",
    fill: "#228B22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L30 8L35 12L32 15L28 15Z",
    fill: "#228B22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12L40 8L45 12L42 15L38 15Z",
    fill: "#228B22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15L50 11L55 15L52 18L48 18Z",
    fill: "#228B22"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 22,
    rx: 3,
    ry: 4,
    fill: "#000"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 22,
    rx: 3,
    ry: 4,
    fill: "#000"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 21,
    rx: 1,
    ry: 1.5,
    fill: "#FFF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 21,
    rx: 1,
    ry: 1.5,
    fill: "#FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28C25 32 30 34 35 34C40 34 45 32 48 28C48 30 45 32 40 33C35 34 30 34 25 33C22 32 22 30 22 28Z",
    fill: "#000"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "26,30 28,32 30,30",
    fill: "#FFF"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "30,30 32,32 34,30",
    fill: "#FFF"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "34,30 36,32 38,30",
    fill: "#FFF"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "38,30 40,32 42,30",
    fill: "#FFF"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "42,30 44,32 46,30",
    fill: "#FFF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 50,
    rx: 4,
    ry: 6,
    fill: "#9ACD32"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 50,
    rx: 4,
    ry: 6,
    fill: "#9ACD32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 40C55 42 58 45 58 50C58 52 55 53 52 52C50 51 48 48 48 45C48 42 49 41 50 40Z",
    fill: "#9ACD32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinoIcon);
export default __webpack_public_path__ + "static/media/dino-icon.860cb06756ad450f408963137e5cf738.svg";
export { ForwardRef as ReactComponent };